import normalizeToGeneralSettings from './fromAPI/toGeneralSettings';
import normalizeToPartnerSpecificSettings from './fromAPI/toPartnerSpecificSettings';
import normalizeToTriggerSettings from './fromAPI/toTriggerSettings';

import normalizeToBusinessAPI from './fromState/toBusinessAPI';
import normalizeToDeploymentsAPI from './fromState/toDeploymentsAPI';
import normalizeToTriggersAPI from './fromState/toTriggersAPI';
import normalizeToDefaultTeamAPI from './fromState/toDefaultTeamAPI';

const normalizers = {
  fromBusinessAPI(data) {
    return {
      generalSettings: normalizeToGeneralSettings(data),
      partnerSpecificSettings: normalizeToPartnerSpecificSettings(data),
      botPromptTriggerSettings: normalizeToTriggerSettings(data),
    };
  },

  toBusinessAPI(data, meta) {
    return JSON.parse(
      JSON.stringify({
        businessData: normalizeToBusinessAPI(data, meta),
        platformDeployments: normalizeToDeploymentsAPI(data, meta),
        botPromptTriggers: normalizeToTriggersAPI(data, meta),
        defaultTeam: normalizeToDefaultTeamAPI(data, meta),
      })
    );
  },
};

export default normalizers;
